import React, { useState, useEffect } from 'react';
import { Card, Table, Form, Button } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import Pagination from 'react-js-pagination';
import { useQuery, useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { ConfirmModal } from '../../../../../modules/modal/ConfirmModal';
import { AsyncPaginate } from 'react-select-async-paginate';
import { MUCDANHGIA_API, TIEUCHI_API } from '@app/utils/apiUrl';
import { Get, DeleteSingle } from '@app/utils/httpProvider';
import { messageToast, status200, objectShowNumber, styleSelectDefault } from '../../../../../utils/define';
import { useSelector } from 'react-redux';
import { URI_INTERNAL } from '../../../../../utils/pathLocations';

const MucDanhGia = (props) => {
    const { history } = props;
    const location = require('react-router-dom').useLocation();
    const valueSearch = useSelector((state) => state.search.valueSearch);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [search, setSearch] = useState('');

    const paramUrl = new URLSearchParams(location.search.substring(1));
    if (paramUrl.get('page') != null && parseInt(paramUrl.get('page'), 10) !== page) {
        setPage(parseInt(paramUrl.get('page'), 10));
    }
    if (paramUrl.get('pageSize') != null && parseInt(paramUrl.get('pageSize'), 10) !== pageSize) {
        setPageSize(parseInt(paramUrl.get('pageSize'), 10));
    }
    if (paramUrl.get('search') != null && paramUrl.get('search') !== search) {
        setSearch(paramUrl.get('search'));
    }
    const [tieuChiId, setTieuChiId] = useState(null);

    const [idWantDelete, setIdWantDelete] = useState('');
    const [confirmDelMessage, setConfirmDelMessage] = useState('');
    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);

    const replaceHistory = (page, pageSize, search) => {
        history.replace(`${URI_INTERNAL.MUCDANHGIA_PATH}?page=${page}&pageSize=${pageSize}&search=${search}`);
    };

    const { data, refetch, isLoading, isError, error } = useQuery(
        ['mucDanhGiaList', page, pageSize, valueSearch],
        () => Get(MUCDANHGIA_API.GET_PAGING, null, {
            pageIndex: page,
            pageSize: pageSize,
            keyword: valueSearch || '',
            tieuChiId: tieuChiId || ''
        }, false),
        {
            keepPreviousData: true
        }
    );

    useEffect(() => {
        refetch();
    }, [page, pageSize, tieuChiId]);

    useEffect(() => {
        if (valueSearch != null && valueSearch !== search) {
            setPage(1);
            replaceHistory(1, pageSize, valueSearch);
        }
    }, [valueSearch]);

    const changePage = (number) => {
        setPage(number);
        replaceHistory(number, pageSize, search);
    };

    const onChangeShowNumber = (e) => {
        setPageSize(Number(e.target.value));
        replaceHistory(page, Number(e.target.value), search);
    };

    const deleteFunc = useMutation((value) => DeleteSingle(MUCDANHGIA_API.DELETE_ITEM, value, null));

    const deleteAction = (id, name) => {
        setIdWantDelete(id);
        setConfirmDelMessage(name);
        setOpenConfirmDeleteModal(true);
    };

    const acceptDelete = () => {
        if (!idWantDelete) return;

        deleteFunc.mutate(idWantDelete, {
            onSuccess: (res) => {
                if (res.status === status200 || res.status === 201) {
                    toast.success(messageToast.messageToastDeleteSuccess);
                    refetch();
                } else {
                    toast.error(messageToast.messageToastDeleteError);
                }
            },
            onError: (err) => {
                toast.error(err?.message || messageToast.messageToastTryCatch);
            }
        });

        setOpenConfirmDeleteModal(false);
        setIdWantDelete('');
    };

    const cancelDelete = () => {
        setIdWantDelete('');
        setOpenConfirmDeleteModal(false);
    };

    const items = data?.data?.$values ? data.data.$values : data?.data || [];
    const totalRecords = data?.totalRecords || 0;

    const loadOptionsTieuChi = async (search, loadedOptions, { page }) => {
        const pageSize = 10;
        const res = await Get(TIEUCHI_API.GET_PAGING, null, {
            PageIndex: page,
            PageSize: pageSize,
            Keyword: search
        });

        const dataList = res.data?.data || res.data || [];
        const options = dataList.map((x) => ({
            label: x.tenTieuChi || x.TenTieuChi,
            value: x.id || x.Id
        }));

        const hasMore = dataList.length === pageSize;
        return {
            options,
            hasMore,
            additional: { page: page + 1 }
        };
    };

    return (
        <div className="container-fluid">
            <Card>
                <Card.Header>
                    <div className="d-flex justify-content-between align-items-center">
                        <h5>Danh mục mục đánh giá</h5>
                        <div className="d-flex">
                            <NavLink to={URI_INTERNAL.MUCDANHGIA_CREATE_PATH} className="btn btn-success">
                                Thêm mới
                            </NavLink>
                        </div>
                    </div>
                </Card.Header>
                <Card.Body>
                    <div className="row mb-3">
                        <div className="col-md-3">
                            <AsyncPaginate
                                name="tieuChiId"
                                id="tieuChiId"
                                placeholder="Chọn tiêu chí"
                                value={tieuChiId ? { value: tieuChiId, label: 'Đang chọn...' } : null}
                                loadOptions={loadOptionsTieuChi}
                                styles={styleSelectDefault}
                                isClearable
                                onChange={(selectedOption) => {
                                    setTieuChiId(selectedOption?.value || null);
                                    setPage(1);
                                }}
                                additional={{
                                    page: 1
                                }}
                            />
                        </div>
                    </div>

                    <div className="table-responsive">
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>STT</th>
                                    <th>Tiêu chí</th>
                                    <th>Tên mục đánh giá</th>
                                    <th>Điểm số</th>
                                    <th>Hành động</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    <tr>
                                        <td colSpan={5}>Đang tải...</td>
                                    </tr>
                                ) : isError ? (
                                    <tr>
                                        <td colSpan={5}>Lỗi: {error?.message || 'Không tải được dữ liệu'}</td>
                                    </tr>
                                ) : items.length === 0 ? (
                                    <tr>
                                        <td colSpan={5}>Không có dữ liệu</td>
                                    </tr>
                                ) : (
                                    items.map((item, index) => (
                                        <tr key={item.id || index}>
                                            <td>{(page - 1) * pageSize + index + 1}</td>
                                            <td>{item.tieuChi?.tenTieuChi || item.TieuChi?.TenTieuChi}</td>
                                            <td>{item.tenMucDanhGia || item.TenMucDanhGia}</td>
                                            <td>{item.diemSo ?? item.DiemSo}</td>
                                            <td>
                                                <NavLink
                                                    className="btn btn-primary btn-sm mr-2"
                                                    to={`${URI_INTERNAL.MUCDANHGIA_EDIT_PATH}?id=${item.id}`}>
                                                    Sửa
                                                </NavLink>
                                                <Button
                                                    variant="danger"
                                                    size="sm"
                                                    onClick={() => deleteAction(item.id, item.tenMucDanhGia || item.TenMucDanhGia)}>
                                                    Xóa
                                                </Button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </Table>
                    </div>

                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                            <Form.Control as="select" value={pageSize} onChange={onChangeShowNumber} style={{ width: '100px' }}>
                                {objectShowNumber.map((opt) => (
                                    <option key={opt.value} value={opt.value}>{opt.text}</option>
                                ))}
                            </Form.Control>
                        </div>
                        <div>
                            <Pagination
                                itemClass="page-item"
                                linkClass="page-link"
                                innerClass="pagination pagination-sm no-margin"
                                activePage={page}
                                itemsCountPerPage={pageSize}
                                totalItemsCount={totalRecords}
                                pageRangeDisplayed={5}
                                onChange={changePage}
                            />
                        </div>
                    </div>

                    <ConfirmModal
                        isOpen={openConfirmDeleteModal}
                        confirmType="delete"
                        handleAccept={acceptDelete}
                        handleCancel={cancelDelete}
                        content={confirmDelMessage}
                    />
                </Card.Body>
            </Card>
        </div>
    );
};

export default MucDanhGia;
